import prints from "@/components/prints/print_waiFa.vue";
import printDialog from "@/components/printDialog/index.vue";
import printSys from "@/components/printSys/index.vue";
import printSysContent from "@/components/printSys/content.vue";
import classNameDialog from "@/components/Dialog.vue";
import { hiprint } from "@/print.js";
export const mixin_print = {
    components: {
        prints,
        printDialog,
        printSys,
        printSysContent,
        classNameDialog,
    },
    data() {
        return {
            // 打印模块
            // 打印预览
            classNameDiaWidth: "300px",
            classNameDialogTitle: "请选择className",
            isShowClassNameDialog: false,

            isShowDialog_print: false,
            diaWidth_print: "90%",
            dialogTitle_print: "打印预览",
            dataList: [],
            topData: {},

            // 打印弹出框
            dialogFrom: {
                dialogVisible: false,
            },
            // 创建新的打印
            printForm: {
                dialogVisible: false,
            },
            printTitle: "创建模板",
            printType: 1, // 1是创建 2是使用
            // 打印
            printDesignForm: {
                dialogVisible: false,
            },
            // 选择的模板数据
            modelObj: null,

        }
    },
    created() {

    },
    methods: {



        handleCloseClassNameDia() {
            this.isShowClassNameDialog = false;
        },
        classNameDiaCancelBtn() {
            this.isShowClassNameDialog = false;
        },
        classNameDiaConfirmBtn() {
            if (!this.modelClassName) {
                this.$message.error("请选择className");
                return;
            }
            this.isShowClassNameDialog = false;
            setTimeout(() => {
                this.dialogFrom.dialogVisible = false;
                this.printTitle = "创建模板";
                this.printType = 1;
                this.modelObj = null;
                setTimeout(() => {
                    this.printForm.dialogVisible = true;
                }, 300);
            }, 300);
        },
        // 打印系统关闭
        handlePrintSysClose() {
            if (this.$refs.dialogSelect) {
                this.$refs.dialogSelect.doSearch();
            }
        },
        // 打印弹出框创建
        handleCreated() {
            this.isShowClassNameDialog = true;
        },
        // 打印预览模板
        handleEdit(obj) {
            console.log(obj, 'obj')
            this.modelClassName = obj.className || ''
            // this.dialogFrom.dialogVisible = false;
            this.printTitle = obj.modelName;
            this.printType = 2;
            this.modelObj = obj;
            setTimeout(() => {
                this.printForm.dialogVisible = true;
            }, 300);
        },


        // 打印相关的
        handleCloseDia_print() {
            this.isShowDialog_print = false;
        },
        // 打印预览确定
        diaConfirmBtn_print() {
            this.isShowDialog_print = false;
        },
        // 打印相关的


    },

}